import React, { Component } from "react";
import debounce from "lodash/debounce";

const isMobile = ComposedComponent => {
  class CheckMobile extends Component {
    constructor(props) {
      super(props);
      this.state = {
        isMobile: window.innerWidth <= 767
      };
      this.handleWindowSizeChangeDebounced = debounce(
        this.handleWindowSizeChange,
        300
      );
    }

    componentWillMount() {
      window.addEventListener("resize", this.handleWindowSizeChange);
    }

    // make sure to remove the listener
    // when the component is not mounted anymore
    componentWillUnmount() {
      window.removeEventListener("resize", this.handleWindowSizeChange);
    }

    handleWindowSizeChange = () => {
      if (
        (window.innerWidth <= 767 && !this.state.isMobile) ||
        (window.innerWidth > 767 && this.state.isMobile)
      ) {
        this.setState({ isMobile: !this.state.isMobile });
      }
    };

    render() {
      return (
        <ComposedComponent {...this.props} isMobile={this.state.isMobile} />
      );
    }
  }
  return CheckMobile;
};

export { isMobile };



// WEBPACK FOOTER //
// ./src/hocs/isMobile.js